<template>
	<div v-loading.fullscreen.lock="loading" class="companyHome">
		<div class="companyHomeCon">
			<div class="head container">
				<div>
					公司主页
				</div>
			</div>
			<div class="comInfo container">
				<div class="left">
					<el-image :src="info.logo" fit="cover" class="logo"></el-image>
					<div class="nameNum">
						<div class="name">
							{{info.company_name}}
						</div>
						<div class="num">
							{{info.person_count}}
						</div>
						<div class="num">
							{{info.company_address}} {{info.address_detail}}
						</div>
					</div>
				</div>
				<div class="right">
					<i class="el-icon-edit-outline" style="font-size: 24px;" @click="edit()"></i>
					<!-- <div class="label">
						<div class="li">
							{{info.company_address.split('-')[1]}}
						</div>
						<div class="li">
							{{info.address_detail}}
						</div>
						<div class="li">
							学历不限
						</div>
					</div> -->
				</div>
			</div>
		
		    <poDe :type='3' :details='info'></poDe>
		</div>
		
	</div>
</template>

<script>
	import poDe from '@/components/poDe.vue'
	export default {
		components:{
			poDe
		},
		data() {
			return {
				loading:false,
				info:''
			}
		},
		created() {
			this.getInfo()
		},
		methods: {
			getInfo(){
				this.loading = true
				this.$axios.get('/api/client/ES/getCompanyData').then(res => {
					this.loading = false
					if (res.code == 200) {
						this.info=res.data
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			edit(){
				this.$router.push({ name: 'setBusiness',query:{type:2,status:2}});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.companyHome{
		position: relative;
		padding: 24px 0;
		display: flex;
		justify-content: center;
		.companyHomeCon{
			width: 1200px;
			margin: 0 auto;
			position: relative;
			z-index: 2;
			.container{
				padding: 28px 32px;
				background-color: #FFF;
				border-radius: 12px;
				margin-bottom: 24px;
			}
			.head{
				font-size: 28px;
			}
			.el-icon-edit-outline{
				cursor: pointer;
				margin-left: 8px;
				&:hover {
					color: #51A190;
				}
			}
			
			.comInfo{
				display: flex;
				align-items: center;
				justify-content: space-between;
				.left{
					display: flex;
					align-items: center;
					.logo{
						width: 96px;
						height: 96px;
						margin-right: 28px;
						border-radius: 8px;
					}
					.nameNum{
						color: #151515;
						.name{
							font-size: 28px;
							margin-bottom: 7px;
							font-weight: bold;
						}
						.num{
							font-size: 14px;
						}
					}
				}
				.right{
					display: flex;
					flex-direction: column;
					align-items: flex-end;
					justify-content: space-between;
					height: 96px;
					.el-icon-edit-outline{
						cursor: pointer;
					}
					.label {
						display: flex;
						align-items: center;
						.li {
							padding: 6px 9px;
							background-color: rgba(81, 161, 144, 0.2);
							border-radius: 4px;
							font-size: 13px;
							color: #51A190;
							margin-right: 8px;
							&:last-child {
								margin-right: 0;
							}
						}
					}
					
				}
			}
		}
		
		
		
	}
</style>